import React, { useState } from 'react';
import MarketingContainer from '@redbubble/react-marketing';
import '@redbubble/react-marketing/lib/styles.css';

export const MarketingFooter = () => {
  const [isShowing, setShowing] = useState(true);

  return isShowing ? (
    <MarketingContainer
      collapse
      showLoader
      timeout={15000}
      onFailure={() => setShowing(false)}
      contentId="digioh-footer-signup"
      loaderStyles={{
        backgroundColor: 'transparent'
      }}
      containerStyles={{
        height: 210,
        position: 'relative',
        backgroundColor: 'var(--ds-color-white)',
        borderTop: '2px solid var(--ds-color-neutral-100)',
        borderBottom: '2px solid var(--ds-color-neutral-100)'
      }}
    />
  ) : null;
};
